export enum DocumentType {
  Any,
  ProfilePicture,
  Diploma,
  MedicalCondition,
  BirthCertificate,
  Relocation,
  MealMenu,
}
